module.exports = __webpack_public_path__ + "img/Help.a485bcbb.gif";